export const getStatus = (status) => {
  const i18n = window.VUE_CLI_EXPORTS.plugins.i18n

  status = status?.toUpperCase()

  switch (status) {
    case 'CONCEPT':
      return i18n.t('/OrderInfoBlock/StatusConcept')
    case 'QUOTE':
      return i18n.t('/OrderInfoBlock/StatusQuote')
    case 'TO_APPROVE':
      return i18n.t('/OrderInfoBlock/StatusToApprove')
    case 'APPROVED':
      return i18n.t('/OrderInfoBlock/StatusApproved')
    case 'PENDING':
      return i18n.t('/OrderInfoBlock/StatusPending')
    case 'CONFIRMED':
      return i18n.t('/OrderInfoBlock/StatusConfirmed')
    case 'REJECTED':
      return i18n.t('/OrderInfoBlock/StatusRejected')
    case 'SALESORDER':
      return i18n.t('/OrderInfoBlock/StatusSalesorder')
    default:
      return i18n.t('/OrderInfoBlock/StatusNew')
  }
}
